import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { createFetch, createSchema } from '@better-fetch/fetch';
import { useAppSelector, useAppDispatch } from '../../app/hooks';

// types
import { DataItemType } from '../../utils/types';

// functions

//	--------------------------------------------------------------------------
//
//	T Y P E S
//
//	--------------------------------------------------------------------------

export interface ProjectState {
  //
  loadingComponent: boolean;
  projectItems: DataItemType[];
  filenameFilter: string;
  lifetimeStr: string;
  lifetime: number;
  selectedItems: DataItemType[];
  selectedDivs: number[];
  focusElement: { divID: number };
  errorMessage: string;
  contextMenuRefresh: number;
  computeMaximised: boolean;
  //
} // ProjectState

//	--------------------------------------------------------------------------
//
//	C O N S T A N T S
//
//	--------------------------------------------------------------------------

const initialState: ProjectState = {
  loadingComponent: false,
  projectItems: [],
  filenameFilter: '',
  lifetimeStr: '3600',
  lifetime: 3600,
  selectedItems: [],
  selectedDivs: [],
  focusElement: { divID: 0 },
  errorMessage: '',
  contextMenuRefresh: 0,
  computeMaximised: true,
};

//	--------------------------------------------------------------------------
//
//	F U N C T I O N S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	S L I C E S
//
//	--------------------------------------------------------------------------

export const projectSlice = createSlice({
  name: 'project',
  initialState: initialState,
  reducers: {
    //
    addToSelectedDivs: (state: ProjectState, action: PayloadAction<number[]>) => {
      state.selectedDivs = [
        ...state.selectedDivs,
        ...action.payload.filter((filter) => {
          return state.selectedDivs.indexOf(filter) === -1;
        }),
      ];
    },

    removeFromSelectedDivs: (state: ProjectState, action: PayloadAction<number[]>) => {
      state.selectedDivs = state.selectedDivs.filter((filter: number) => {
        return action.payload.indexOf(filter) === -1;
      });
    },

    setComputeMaximised: (state: ProjectState, action: PayloadAction<boolean>) => {
      state.computeMaximised = action.payload;
    },

    setContextMenuRefresh: (state: ProjectState, action: PayloadAction<number>) => {
      state.contextMenuRefresh = action.payload;
    },

    setFocusElement: (state: ProjectState, action: PayloadAction<{ divID: number }>) => {
      state.focusElement = action.payload;
    },

    setProjectItems: (state: ProjectState, action: PayloadAction<DataItemType[]>) => {
      state.projectItems = action.payload;
    },

    setErrorMessage: (state: ProjectState, action: PayloadAction<string>) => {
      state.errorMessage = action.payload;
    },

    setFilenameFilter: (state: ProjectState, action: PayloadAction<string>) => {
      state.filenameFilter = action.payload;
    },

    setLifetime: (state: ProjectState, action: PayloadAction<number>) => {
      state.lifetime = action.payload;
    },

    setLifetimeStr: (state: ProjectState, action: PayloadAction<string>) => {
      state.lifetimeStr = action.payload;
    },

    setLoadingComponent: (state: ProjectState, action: PayloadAction<boolean>) => {
      state.loadingComponent = action.payload;
    },

    setSelectedDivs: (state: ProjectState, action: PayloadAction<number[]>) => {
      state.selectedDivs = action.payload;
    },

    setSelectedItems: (state: ProjectState, action: PayloadAction<DataItemType[]>) => {
      state.selectedItems = action.payload;
    },
    //
  },
  //extraReducers: (builder) => {
  //  builder
  //    .addCase(initiateDMSearch.fulfilled, (state: FileBrowserState) => {})
  //},
});

// expose the interface.
export const {
  addToSelectedDivs,
  removeFromSelectedDivs,
  setComputeMaximised,
  setContextMenuRefresh,
  setFocusElement,
  setProjectItems,
  setErrorMessage,
  setLoadingComponent,
  setFilenameFilter,
  setLifetime,
  setLifetimeStr,
  setSelectedDivs,
  setSelectedItems,
} = projectSlice.actions;
export default projectSlice.reducer;
